import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css']
})
export class PrivacyPolicyComponent implements OnInit {
  Address: string = environment.address;
  ContactNo: string = environment.mobileNo;
  ContactEmail: string = environment.emailId;
  websitename: string = environment.website;
  companyfname: string = environment.companyFullName;

  constructor() { }

  ngOnInit() {
  }

}
